import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'

type Params = {
  slug?: string | null
  type?: IEnum_Solution_Type | null
}

export const getSolutionUrl = (params: Params): string => {
  if (!params?.type || !params?.slug) {
    return '/'
  }

  const solutionType = params.type
  const slug = params.slug
  if (solutionType === IEnum_Solution_Type.Alsp) {
    return `/alsps/${slug}/`
  } else if (solutionType === IEnum_Solution_Type.Consultancy) {
    return `/consultants/${slug}/`
  } else if (solutionType === IEnum_Solution_Type.Product) {
    return `/vendors/${slug}/`
  }
  return '/'
}
